import React, { Component } from "react";
import "../App.css";
import time from "../images/timeCard.png";
import anxiety from "../images/anxietyCard.png";
import meditate from "../images/meditationCard.png";
import gratitude from "../images/gratitudeCard.png";
import hobbies from "../images/hobbiesCard.png";
import zen from "../images/zencard.png";
import { Link } from "react-router-dom";

class MindfullnessPopTopics extends Component {
  render() {
    return (
      <>
        <section className="pop-topics-wrapper">
          <h1>Popular Topics</h1>
          <div className="pop-topics-1">
            <div className="sub-cat-card-wrapper">
              <Link
                to="/mindfulness/philosophies-of-time"
                className="sub-cat-card"
              >
                <img src={time} />
              </Link>
              <h2 className="sub-cat-card-title">Philosophies of Time</h2>
            </div>
            <div className="sub-cat-card-wrapper">
              <Link to="/mindfulness/aleviate-anxiety" className="sub-cat-card">
                <img src={anxiety} />
              </Link>
              <h2 className="sub-cat-card-title">Alleviate Anxiety</h2>
            </div>
            <div className="sub-cat-card-wrapper">
              <Link
                to="/mindfulness/meditation-is-key"
                className="sub-cat-card"
              >
                <img src={meditate} />
              </Link>
              <h2 className="sub-cat-card-title">Meditation is Key</h2>
            </div>
          </div>
          <div className="pop-topics-2">
            <div className="sub-cat-card-wrapper">
              <Link to="/mindfulness/gain-gratitude" className="sub-cat-card">
                <img src={gratitude} />
              </Link>
              <h2 className="sub-cat-card-title">Gain Gratitude</h2>
            </div>
            <div className="sub-cat-card-wrapper">
              <Link
                to="/mindfulness/hobbies-and-habits"
                className="sub-cat-card"
              >
                <img src={hobbies} />
              </Link>
              <h2 className="sub-cat-card-title">Hobbies Help</h2>
            </div>
            <div className="sub-cat-card-wrapper">
              <Link to="/mindfulness/zen" className="sub-cat-card">
                <img src={zen} />
              </Link>
              <h2 className="sub-cat-card-title">Zen</h2>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default MindfullnessPopTopics;
